module.exports = __webpack_public_path__ + "2925e709c71c2afad06bee70a117d865.png";